import { api } from './client'

export function fetchSyncStatus() {
  return api.get('/sync/status').then((r) => r.data)
}

export function fetchThreatDownSyncStatus() {
  return api.get('/sync/threatdown/status').then((r) => r.data)
}

export function fetchSyncLogs(limit = 20) {
  return api.get('/sync/logs', { params: { limit } }).then((r) => r.data)
}

export function fetchThreatDownSyncLogs(limit = 15) {
  return api.get('/sync/threatdown/logs', { params: { limit } }).then((r) => r.data)
}

export function triggerSync() {
  return api.post('/sync/trigger').then((r) => r.data)
}

export function triggerThreatDownSync() {
  return api.post('/sync/threatdown/trigger').then((r) => r.data)
}

/** Fired when Sync control refreshes status so the top bar can catch up. */
export const SYNC_STATUS_CHANGED_EVENT = 'bekat:sync-status-changed'

export function notifySyncStatusChanged() {
  if (typeof window !== 'undefined') {
    window.dispatchEvent(new Event(SYNC_STATUS_CHANGED_EVENT))
  }
}
